import { Instance, types } from 'mobx-state-tree';
import { ProgressStateModel } from './progressStateModel';

export type IBaseDesktopApplicationStore = Instance<typeof ApplicationStoreWithFooterVisibility>;

export const evalFooterVisibility = (progressState: ProgressStateModel): boolean => {
    return progressState !== ProgressStateModel.Loading;
}

export const evalFooterVisibilityComposed = (progressState: ProgressStateModel, progressState2: ProgressStateModel): boolean => {
    return progressState !== ProgressStateModel.Loading && progressState2 !== ProgressStateModel.Loading;
}

const ApplicationStoreWithFooterVisibilityKey = 'ApplicationStoreWithFooterVisibilityStore';
export const ApplicationStoreWithFooterVisibility = types
    .model(ApplicationStoreWithFooterVisibilityKey, {
    })
    .actions(_self => {

        return {
        };
    });
